import { fieldTypes } from "@constants/constant";
import { Field } from "@modules/dynamic-form-builder/model/formBuilderInterface";

export const NEW_POST_CONST = {
  SELECT_INTERESTS_HINT: 'Including interest tags related to your post from the list below or your own custom #tags will help you find new fans who share similar interests.',
  DISCOVERY_HINT: 'If you enable this option, this specific post will be viewable to all TopFan users in the Discovery Feed, even though your account is private.',
  WATERMARK_HINT_IMAGE: 'Add a Watermark to protect your content. Note: Once you apply a Watermark, you will need to delete and re-upload images to change the applied Watermark.',
  WATERMARK_HINT_VIDEO: 'Add a Watermark to protect your content. Watermark will be applied within 30 minutes of uploading your video.',
  MAX_TWENTY_IMAGES: 'You cannot select more than 20 images.',
  MAX_SIZE_TEN: 'You cannot upload image size more than 10 MB.',
  OPACITY: 'Opacity',
  GAP: 'Gap',
  FONT_SIZE: 'Font Size',
  GIF_TYPE: 'image/gif',
  ARCHIVE_AS_POST: 'archiveAsPost',
  ARCHIVE_VIDEO_POST: 'Archive as a Video Post after Livestream Ends',
  ARCHIVE_VIDEO_POST_HINT: 'If you enable this option, your livestream will be archived as a video post after the livestream ends. Your same locking settings will automatically be added to the video post. You are able to edit the locking settings at anytime by editing the video post.',
  OCCUPY: 'OCCUPY',
  MAX_LENGTH_1000: '* Maximum Length cannot be greater than 1000.',
  SELECT_INTERESTS: 'Select Interests',
  FEED_PREVIEW_IMAGE: 'Feed Preview Image*',
  UPLOAD: 'Upload',
  TAKE_WEBCAM_PHOTO: 'Take Webcam Photo',
  VIEDO_INPUT_SETTING: 'Video & Input Setting',
  WEBCAM: 'WEBCAM',
  STREAMING_SOFTWARE: 'STREAMING SOFTWARE',
  INPUT_DEVICE: 'Input Device',
  TEST_VIDEO: 'Test Video',
  TEST_AUDIO: 'Test Audio',
  COPY: 'COPY',
  STREAMING_KEY: 'Streaming Key',
  COPY_PASTE_SOFTWARE: 'Copy and paste the 2 fields below into your streaming software.',
  RESET: 'RESET',
  GO_LIVE_NOW: 'GO LIVE NOW',
  ENABLE_MIC_VIDEO: 'Please enable microphone/camera in your browser settings.',
  LIVESTREAM_SETTINGS: 'Livestream Settings',
  CHOOSE_ANY_OPTION: 'Choose any of the options below to lock ',
  THIS_LIVESTREAM: 'this livestream:',
  THIS_CONTENT: 'this content:',
  ENABLE_FREE_PREVIEW_DURATION: 'Enable Free Preview Duration:',
  PREVIEW_IMAGE: 'Preview Image*',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  LIVE: 'Live',
  WANT_TO_END_LIVESTREAM: 'Are you sure you want to end this livestream?',
  ACTIVE: 'ACTIVE',
  FREE_PREVIEW_ENDED: 'Your Free Preview has Ended',
  CHOOSE_OPTION: 'You can continue watching, by choosing an option below.',
  SUBSCRIBE: 'SUBSCRIBE',
  UNLOCK_WITH_NFT: 'UNLOCK WITH NFT',
  END_LIVESTREAM: 'End Livestream',
  LIVE_STREAM: 'Livestream',
  EXIT_LIVESTREAM: 'EXIT LIVESTREAM',
  WATCHING: 'WATCHING',
  WATCH: 'Watch',
  MORE_LIVESTREAMS: 'MORE LIVESTREAMS',
  Active_Livestreams: 'Active Livestreams',
  More: 'More',
  Video_Paused: 'Video Paused',
  LIVESTREAM_SHOPPING: 'Choose Store Item to Feature in Livestream Shopping',
  LIVESTREAM_PORTFOLIO: 'Choose Portfolio to Feature in Livestream',
  LIVESTREAM_EVENT_TICKETING: 'Choose Event to Feature in Livestream',
  UNPRESENT_PORTFOLIO: 'Stop Featuring Portfolio',
  UNPRESENT_EVENT_TICKET: 'Stop Featuring Event',
  UNLOCK_THE_LIVESTREAM_WATCH : 'Unlock the Livestream to Watch',
  UNLOCK_ACCESS_THROUGH_OPTIONS_BELOW: 'You can unlock access through the options below:',
  Creator_Paused_Video: 'Creator Paused Video Momentarily',
  Creator_Paused_Video_Audio: 'Creator Paused Video & Muted Audio Momentarily',
  Creator_Paused_Audio: 'Creator Muted Audio Momentarily',
  UNPRESENT_STORE: 'Stop Featuring Item',
  CREATE_A_LIVESTREAM: 'Create a Livestream',
  SELECT_SUBSCRIPTION: 'Select Subscription Plan to Review Details:',
  SELECT_DURATION: 'Select Duration',
  ONE_MONTH: '1 Month',
  MONTHS: ' Months',
  BACK_TO_PLANS: 'Back to Plans',
  ALREDY_SUBSCRIBED: 'This subscription plan is already subscribed.',
  JOIN_LIVESTREAM: 'JOIN THE LIVESTREAM NOW',
  LIVESTREAM_CAM: 'Livestream',
  PRICE_FOR: 'Price for',
  BENEFITS: 'Benefits:',
  FREE_PREVIEW: 'Free Preview',
  Unlock_Livestream: 'Unlock Livestream',
  CHOOSE_OPTION_TO_LOCK_LIVESTREAM: 'Choose at least one option below to lock this livstream:',
  LIVE_SHOP: 'Live Shop',
  UNLOCK_LIVESTREAM: 'UNLOCK LIVESTREAM',
  VIEWERS: 'Current Livestream Viewers',
  WAIT: 'Wait',
  PROCEED: 'Proceed',
  STREAMING_SETUP_INSTRUCTIONS: 'Streaming Setup Instructions',
  GOING_LIVE_IN: 'Going live in',
  SECONDS: 'seconds',
  STREAMING_SETUP_INSTRUCTIONS_TEXT: 'Please follow these steps to set up streaming for live streaming:',
  STREAMING_SETUP_INSTRUCTIONS_TEXT_1: 'Open your streaming software.',
  STREAMING_SETUP_INSTRUCTIONS_TEXT_2: 'Go to Settings → Stream (or equivalent).',
  STREAMING_SETUP_INSTRUCTIONS_TEXT_3: 'Select Custom service or your desired service.',
  STREAMING_SETUP_INSTRUCTIONS_TEXT_4: 'Enter the Server URL & Stream Key provided.',
  STREAMING_SETUP_INSTRUCTIONS_TEXT_5: 'Save the settings.',
  STREAMING_SETUP_INSTRUCTIONS_TEXT_6: 'Start Streaming from your software.',
  NO_VIEWERS: 'No Viewers',
  REQUIRE_ACCOUNT_SIGN_IN_TO_ACCESS: 'Require account Sign In to access this post\'s content',
  REQUIRE_ACCOUNT_SIGN_IN_TO_ACCESS_HINT:
    'When you require Sign In to access the content, guest users who arrive on it from a shared link, will also be required to create an account before being able to access the content.',
  MORE_ACTIONS: 'More Actions',
  AUDIO_UNMUTE: 'Audio Unmute',
  AUDIO_MUTED: 'Audio Muted',
  CAMERA_ON: 'Camera On',
  CAMERA_OFF: 'Camera Off',
  SHARE: 'Share',
  KICKED: 'KICKED',
  POLL_SCHEDULE_DATE_EXCEEDS_EXPIRY:
    'Poll schedule date cannot be greater than poll expiry date.',
  REQUIRE_ACCOUNT_SIGN_IN_TO_READ: 'Require Account Sign In to Read',
  REQUIRE_ACCOUNT_SIGN_IN_TO_LISTEN: 'Require Account Sign In to Listen',
  REQUIRE_ACCOUNT_SIGN_IN_TO_VIEW: 'Require Account Sign In to View',
  HIDE_COMMENTS: 'Hide Comments',
  SHOW_COMMENTS: 'Show Comments',
  REMOVE: 'Remove',
  REMOVE_USER: 'Remove User',
  ADJUST_YOUR_IMAGE: 'Adjust Your Image',
  RECOMMENDED_SIZE: 'Recommended Size: ',
  FUNDRAISER: 'Fundraiser',
  BUY_TICKET: 'Buy Ticket',
  POOR_CONNECTIVITY_ALERT: 'Poor Connectivity Alert',
  POOR_CONNECTIVITY_MESSAGE:
    'Your current internet connection is poor which will result in a low quality video experience for your audience and the replay video will be low quality too.',
  CONTINUE: 'Continue'
}

export const ARCHIVE_AS_POST = {
  type: fieldTypes.CHECKBOX,
  label: '',
  placeholder: '',
  name: NEW_POST_CONST.ARCHIVE_AS_POST,
  class: 'col-12',
  options: [
    {
      label: NEW_POST_CONST.ARCHIVE_VIDEO_POST,
      value: 'YES'
    }
  ],
  labelKey: 'label',
  valueKey: 'value',
  infoIconMessageLbl: NEW_POST_CONST.ARCHIVE_VIDEO_POST_HINT,
  infoIconMessageCls: 'ml-0'
};

export const ingestionField: Field = {
  type: fieldTypes.TEXT,
  label: 'Ingestion Endpoint/Server',
  placeholder: 'Unable to fetch server. Please try again.',
  name: 'server_url',
  class: 'col-10',
  styleClass: 'mt-2 streaming-utility',
  disabled: true
}

export const streamingKey: Field = {
  type: fieldTypes.TEXT,
  label: '',
  placeholder: 'Unable to fetch stream key. Please try again.',
  name: 'stream_key',
  class: 'col-8',
  styleClass: 'mt-2 streaming-utility',
  disabled: true
};

export const ERROR_MSG = {
  TEXT_COPIED: 'Text copied to clipboard!',
  PLEASE_SELECT_CAM_MIC: 'Please select your camera and microphone input devices.'
}

export const freePreviewLock = [
  {
    id: 0,
    label: 'No Free Preview',
  },
  {
    id: 1,
    label: '1 Minute',
  },
  {
    id: 5,
    label: '5 Minutes',
  }, {
    id: 10,
    label: '10 Minutes',
  }, {
    id: 20,
    label: '20 Minutes',
  }, {
    id: 30,
    label: '30 Minutes',
  }
];

export const POST_PRICE_LOYALTY = {
  TOGGLE_LABEL: 'Loyalty Points',
  LABEL: 'Allow users to unlock this content with loyalty points',
  INPUT_SUFFIX: 'Points',
  MIN: 1,
  MAX: 10000,
  RANGE_HINT: 'Enter a value between 1 and 10,000',
  POINTS_REQUIRED: 'Enter loyalty points',
  POINT_COIN_ICON_PATH: 'assets/images/svg/feature-icons/point-coin.svg'
} as const;
